import React from 'react';
import Layout from '@/components/Layout';
import HistorialConductaSection from '@/components/HistorialConductaSection';

const HistorialConductaPage = ({ user, onLogout }) => {
  return (
    <Layout user={user} onLogout={onLogout}>
      <HistorialConductaSection showHeader={true} canDelete={true} />
    </Layout>
  );
};

export default HistorialConductaPage;
